var o = Object.defineProperty;
var u = (s, n, e) => n in s ? o(s, n, { enumerable: !0, configurable: !0, writable: !0, value: e }) : s[n] = e;
var i = (s, n, e) => u(s, typeof n != "symbol" ? n + "" : n, e);
import { HttpClient as a, httpClient as t } from "../../httpClient.js";
class p extends a {
  constructor() {
    super(...arguments);
    i(this, "endpoint", "/course-hearings");
  }
  async getCourseHearings(e) {
    return t.get(this.endpoint, { params: e });
  }
  async getCourseHearing(e) {
    return t.get(`${this.endpoint}/${e}`);
  }
  async reviewSubmission(e, r) {
    return t.put(
      `${this.endpoint}/submissions/${e}/review`,
      r
    );
  }
}
const d = new p();
export {
  d as default
};
